import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/venue/serviceConfig/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/venue/serviceConfig/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/venue/serviceConfig/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/venue/venueApply/submit', params,options)

export const update = (params, options) =>
request.post('/api/venue/serviceConfig/update', params,options)

export const getAreaList = (params, options) =>
request.get('/api/venue/area/loadArea', Object.assign({}, options, { params }));

export const getVenueNameList = (params, options) =>
request.get('/api/venue/manage/getName', Object.assign({}, options, { params }));

export const getVenueTypeList = (params, options) =>
request.get('/api/blade-system/dict/dictionaryWithIntKey?code=venue_type', Object.assign({}, options, { params }));

export const getVenueChargeTypeList = (params, options) =>
request.get('/api/blade-system/dict/dictionaryWithIntKey?code=venue_charge_type', Object.assign({}, options, { params }));

export const getVenueList = (params, options) =>
request.get('/api/venue/manage/loadVenue', Object.assign({}, options, { params }));

export const getApplyList = (params, options) =>
request.get('/api/v4ward/venue/venueApply/getApply', Object.assign({}, options, { params }));

export const getApplyDetail = (params, options) =>
request.get('/api/v4ward/venue/venueApply/detail', Object.assign({}, options, { params }));

export const getServiceConfigList = (params, options) =>
request.get('/api/venue/serviceConfig/config', Object.assign({}, options, { params }));

export const getVenueFee = (params, options) =>
request.get('/api/v4ward/venue/venueApply/calculate/fee', Object.assign({}, options, { params }));

export const getVenueApplyMember = (params, options) =>
request.get('/api/v4ward/venue/venueApplyMember/loadMember', Object.assign({}, options, { params }));

export const addVenueApplyMember = (params, options) =>
request.post('/api/v4ward/venue/venueApplyMember/save', params,options);

export const removeVenueApplyMember  = (params, options) =>
request.post('/api/v4ward/venue/venueApplyMember/remove', qs.stringify(params),options);

export const getAllServiceConfigList = (params, options) =>
request.get('/api/venue/serviceConfig/configByVenueId', Object.assign({}, options, { params }));

export const venueApplyRemove = (params, options) =>
request.post('/api/v4ward/venue/venueApply/remove', qs.stringify(params),options);






